// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@nuxt/postcss8/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".yazio-author-categories{height:76px}.yazio-other-categories{box-shadow:0 1px 15px rgba(191,200,225,.5)}.yazio-category-icon path{fill:#fff}.yazio-other-icon{cursor:pointer}.yazio-other-icon path{fill:#424242}.yazio-other-icon.active{color:#9686c9}.yazio-other-icon.active path{fill:#9686c9}.yazio-other-icon:hover{color:#9686c9}.yazio-other-icon:hover path{fill:#9686c9}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
